import { render, staticRenderFns } from "./VoiceDataList.vue?vue&type=template&id=7330a6f6&scoped=true"
import script from "./VoiceDataList.vue?vue&type=script&lang=js"
export * from "./VoiceDataList.vue?vue&type=script&lang=js"
import style1 from "./VoiceDataList.vue?vue&type=style&index=1&id=7330a6f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330a6f6",
  null
  
)

export default component.exports